require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-inspire-wellness-within.json") })
        }
      }, "path---news-inspire-wellness-within");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-inspire-wellness-within!./.cache/json/news-inspire-wellness-within.json
// module id = 822
// module chunks = 231608221292675